import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Grid } from "@material-ui/core"
import { obtenerSueldoBase, clearState } from "../../../ducks/cotizacionDuck"
import { MPagoAgenteStyle } from "./styles"
import ModalBase from "../../../global/ModalBase"
import HeaderModal from "../../../global/headerModal"
import BackDrop from "./../../../global/BackDrop"
import TResumen from "../TResumen"
import TComisiones from "../TComisiones"

const MPagoAgente = (props) => {

    const {
        open = false,
        setOpenModal = () => {}
      } = props;

    const classes = MPagoAgenteStyle();
    const dispatch = useDispatch()
    const pagoAgente = useSelector(store => store.cotizacion.pagoAgente);
    const resumenMarcado = useSelector(store => store.cotizacion.resumenMarcado);
    const [isLoad, setIsLoad] = useState(false);

    useEffect(()=>{
        if(open)
        {
          setIsLoad(true);
          dispatch(obtenerSueldoBase()).then((Response) =>{
              setIsLoad(false)
          })
        }
      },[dispatch, open])

    const handleCloseModal = () => {
        dispatch(clearState())
        setOpenModal(false);
    };
    

    return (
        <ModalBase classes={classes} open={open} onClose={handleCloseModal}>
            <HeaderModal
            handleClose={handleCloseModal}
            titulo={"Pago Agente"} 
            />
            <Grid container >
                <Grid item xs={12} >
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <h2>{`Fecha del pago: ${pagoAgente.FechaPago}`}</h2>
                </div>
                </Grid>
                <Grid item xs={12}  >
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <TResumen
                        tituloTabla={'Resumen Pago'}
                        resumen={resumenMarcado}
                    />
                    <TComisiones 
                        rows={pagoAgente.cotizaciones} 
                        isPago = {false}
                        isReporte= {true}
                    />
                </div>
                </Grid> 
            </Grid>
            <BackDrop open={isLoad} />
        </ModalBase>
    );
}
export default MPagoAgente